export { ReadOnlyMessage } from './read-only-message';
